"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkName = exports.sdkVersion = void 0;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../package.json');
exports.sdkVersion = packageJson.version;
exports.sdkName = 'js-client-sdk';
//# sourceMappingURL=sdk-data.js.map